// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import Vant from "vant";
import { Notify } from "vant";
import { Popover } from "vant";
import { ActionSheet } from "vant";
import { Lazyload } from "vant";
import Cookies from "js-cookie";
import "./style/tailwind-out.css";
import "vant/lib/index.css";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI, { zIndex: 3000 });


import VueWechatTitle from "vue-wechat-title";
Vue.use(VueWechatTitle);
Vue.config.productionTip = false;
import "./iconfont/iconfont.css";
import "./index.css";
import "./rem.js";
import { apiPost } from "@/api/api";
import VideoPlayer from "vue-video-player";
require("video.js/dist/video-js.css");
require("vue-video-player/src/custom-theme.css");
import { clearPermission } from "@/utils/permissionLib";
import AvatarImg from "@/components/common/AvatarImg";
import { setLocal } from "@/utils/com";
import EmptyPage from "@/components/common/EmptyPage";
Vue.component("emptyPage", EmptyPage); //tab权限 默认访问的组件

import etmsConfig from "@/api/etmsConfig";
Vue.prototype.etmsConfig = etmsConfig;

Vue.component("AvatarImg", AvatarImg);
Vue.use(VideoPlayer);
Vue.use(Vant);
Vue.use(Cookies);
Vue.use(Notify);
Vue.use(Popover);
Vue.use(Lazyload);
Vue.use(ActionSheet);
import moment from "moment";
Vue.prototype.$moment = moment; //赋值使用
moment.locale("zh-cn"); //需要汉化
import echarts from "echarts";
Vue.use(echarts);
import img from "@/api/img";
Vue.prototype.etmsimg = img;
Vue.prototype.$echarts = echarts;
Vue.config.productionTip = false;
import loginCache from "@/utils/loginCache";
function getQueryVariable(variable) {
  var query = window.location.search.substring(1);
  var vars = query.split("&");
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=");
    if (pair[0] == variable) {
      return pair[1];
    }
  }
  return false;
}
function getState(variable) {
  var query = window.location.search.substring(1);
  var vars = query.split("&");
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=");
    if (pair[0] == variable) {
      return pair[1];
    }
  }
}
let byCodeFlag = true;
import router from "./router";

router.beforeEach(async (to, from, next) => {
  if (from.meta.keepAlive) {
    const $wrapper = document.querySelector(".wrapList");
    const scrollTop = $wrapper ? $wrapper.scrollTop : 0;
    from.meta.scrollTop = scrollTop;
  }
  to.meta.title && (document.title = to.meta.title);
  let token = loginCache.getCache();
  let tenantNo = to.params.tenantNo;
  let company = 0;
  if (to.query && to.query.company) {
    company = to.query.company;
  }
  var tn = "";
  if (to.query && to.query.tn) {
    tn = to.query.tn;
  }
  if (to.name == "login" || to.name == "login2" || to.name == "loginSimple") {
    clearPermission();
  }
  if (to.name == "login") {
    //页面是否登录
    if (token) {
      if (tenantNo && tenantNo != "000") {
        router.replace({ name: "loginTool", params: { tenantNo: tenantNo } });
      } else {
        router.replace({ path: "/homePage" });
      }
    } else {
      if (tenantNo) {
        localStorage.setItem("tenantNols", tenantNo);
        if (getQueryVariable("code") && getState("state") != 2) {
          if (byCodeFlag) {
            byCodeFlag = false;
            apiPost("/user/LoginH5ByCode", {
              code: getQueryVariable("code"),
              tenantNo,
              company
            })
              .then(res => {
                console.log(res);
                if (res.code === "10000" && res.resultData.type === 1) {
                  loginCache.setCache(res.resultData.loginInfo.token);
                  apiPost("/user/loginInfoH5", {}).then(ress => {
                    let userinfo = ress.resultData;
                    setLocal("userInfoLs", userinfo, 30);
                    location.href = `${etmsConfig.ErmsUrl}/#/homePage`;
                  });
                }
              })
              .catch(err => {
                console.log(err);
              });
          }
          to.params.id = getQueryVariable("code");
          next();
        } else {
          next();
          apiPost("/user/userGetAuthorizeUrl", {
            sourceUrl: `${etmsConfig.ErmsUrl}/#/login/${tenantNo}?company=${company}&tn=${tn}`,
            tenantNo,
            company
          }).then(res => {
            location.href = res.resultData;
          });
        }
      } else {
        router.replace({ path: "/loginOut" });
      }
    }
  }
  if (
    to.name == "loginPhone" ||
    to.name == "loginPhoneIos" ||
    to.name == "loginSimple"
  ) {
    if (token) {
      router.replace({ path: "/homePage" });
    } else {
      next();
    }
  }
  if (to.name == "loginUnion") {
    if (token) {
      router.replace({ path: "/homePage" });
    } else {
      next();
    }
  }
  if (to.name == "login2") {
    if (token) {
      router.replace({ path: "/homePage" });
    }
  } else if (to.name == "wxMsg") {
    next();
  }
  if (to.name == "homePage") {
    let flag = localStorage.getItem("lsBindWechatFlag");
    if (flag) {
      localStorage.removeItem("lsBindWechatFlag");
      if (getQueryVariable("code")) {
        apiPost("/user/userBindingWeChat", {
          code: getQueryVariable("code")
        }).then(res => {});
      }
    }

    let flagLogin = localStorage.getItem("lsBindWechatLogin");
    if (flagLogin) {
      localStorage.removeItem("lsBindWechatLogin");
      if (getQueryVariable("code")) {
        apiPost("/user/userBindingWeChat", {
          code: getQueryVariable("code")
        }).then(res => {});
      }
    }
  }
  next();
});

//区分定制化

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");



// WEBPACK FOOTER //
// ./src/main.js